import { createSlice } from "@reduxjs/toolkit";

const clientSecretsSlice = createSlice({
  name: "clientSecrets",
  initialState: { client_id: "", client_secret: "" },
  reducers: {
    setClientSecrets: (state, action) => {
      state.client_id = action.payload.client_id;
      state.client_secret = action.payload.client_secret;
    },
  },
});

export const { setClientSecrets } = clientSecretsSlice.actions;
export default clientSecretsSlice.reducer;
